//#region Libraries
import { 
    useLocation 
} from "react-router-dom";
//#endregion
//#region Styles
import {
    Container, 
    ContainerListItems 
} from "./styles";
//#endregion
//#region Icons
import HomeIcon from "icons/HomeIcon";
//#endregion
//#region Components
import ListItem from "./components/ListItem/ListItem"; 
import MenuButton from "./components/MenuButton/MenuButton"; 
import { INFO_MODULE_VIEWS } from "config/userPermissions";
//#endregion
//#region Utils
import ABSOLUTE_PATHS from "routes/utils/absolutePaths";
//#endregion

const INFORMATION_LINKS = [
    { 
        text: "Home", 
        to: ABSOLUTE_PATHS.HOME, 
        icon: <HomeIcon/> 
    },
    ...[
        "Eventos", "Refuezo A.", 
        "Asesorías", "Recursos",
        "Config."
    ].map((text, idx) => {
        const { path, ...restInfoModuleViews } = INFO_MODULE_VIEWS[idx];
        return { 
            text, 
            to: `/${path}`,
            ...restInfoModuleViews 
        };
    })
];


const Sidebar = ({
    moduleIdsViewsOfCurrentUser
}) => {
    const location = useLocation();
    const userHasPermissions = info => {
        return !info?.id || moduleIdsViewsOfCurrentUser.includes(info.id);
    }
    return (
        <Container>
            <ul>
                <MenuButton/>
                <ContainerListItems>
                    {INFORMATION_LINKS.map((info, idx) => {
                        // Verificando permisos según el usuario
                        if (!userHasPermissions(info))
                            return null;
                        return (
                            <ListItem 
                                key={idx}
                                to={info.to} 
                                text={info.text}
                                icon={info.icon}
                                active={location.pathname.startsWith(info.to)}
                                borderTop={info.to === ABSOLUTE_PATHS.SETTING}/>
                        );
                    })}
                </ContainerListItems>
            </ul>
        </Container>
    )
}

export default Sidebar;